import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_ANNOUNCEMENTS_ADMIN_ACTION_TYPE } from '../actions';

const initialState = {
  announcements: [],
};

const commandCenterAnnouncementsAdminReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_ANNOUNCEMENTS_ADMIN_ACTION_TYPE.GET_ANNOUNCEMENTS:
        draft.announcements = payload;
        break;

      case RESET_STATE:
      case COMMAND_CENTER_ANNOUNCEMENTS_ADMIN_ACTION_TYPE.RESET_ANNOUNCEMENTS_STATE:
        return initialState;

      default:
        break;
    }
  });

export default commandCenterAnnouncementsAdminReducer;
